var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 36,
    viewBox: "0 0 121 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120.962,
    height: 36,
    rx: 18,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119.962,
    height: 35,
    rx: 17.5,
    stroke: "#979797",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.116 10.394a2.497 2.497 0 0 1-2.499 2.495c-1.38 0-2.5-1.117-2.5-2.495a2.498 2.498 0 0 1 2.5-2.496c1.38 0 2.5 1.117 2.5 2.496zm-.762 0c0 .957-.777 1.733-1.736 1.733a1.734 1.734 0 0 1-1.736-1.734c0-.957.777-1.733 1.736-1.733s1.736.776 1.736 1.733zM50.74 8.054h-2.777V12.702h.764v-.001h2.013v-.555h-2.013v-1.525h1.805v-.555h-1.805V8.61h2.013v-.555zM53.45 8.054h-1.944v.556h1.18v4.089h.763v-4.09h1.18v-.554h-1.18zM59.437 8.104h-1.18v.555h1.18v4.09h.764v-4.09h1.18v-.555h-1.944z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.8 8.105h.764v4.645H56.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.742 8.104h.903l2.082 3.397V8.104h.764v4.645h-.763v-.002l-2.223-3.625v3.627h-.763V8.104zM45.052 10.194h2.09l-.02.661h-2.07v-.66z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.02 12.862c1.378.012 2.527-.957 2.297-2.64v-.026h-.611c.004.07.006.142.004.216.002 1.201-.692 1.765-1.67 1.765-.977 0-1.77-.79-1.77-1.765 0-.976.793-1.766 1.77-1.766.49 0 .914.167 1.213.472l.477-.476c-.407-.428-1.002-.674-1.71-.674a2.45 2.45 0 0 0-2.453 2.447 2.451 2.451 0 0 0 2.454 2.447zM89.878 16.372h-3.936v5.965h3.936s2.266-.384 2.266-2.982c0-2.599-2.266-2.983-2.266-2.983zm-.5 1.445h-2.672v3.202h2.672s1.216 0 1.216-1.6c0-1.602-1.216-1.602-1.216-1.602z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.595 16.372h1.389v9.705h-1.389zM92.953 16.372h1.389v9.705h-1.389z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.052 19.63c-1.942 0-2.59 1.333-2.59 1.333l1.157.682s.28-.682 1.544-.682c.92 0 1.228.695 1.326 1.073v.285c-.403-.196-1.276-.504-2.522-.32-1.69.252-1.657 1.778-1.652 2.019v.023c0 .136.002 2.152 2.214 2.014.966-.06 1.578-.357 1.96-.672v.69h1.389v-4.228c-.004-.567-.421-2.216-2.826-2.216zm-1.43 4.456c.093-1.5 2.768-.78 2.768-.78s.036.158.036.496c-.238 1.064-2.897 1.784-2.804.284zM104.178 24.067l-1.782-4.226h-1.389l2.477 5.873-1.296 3.072h1.389l3.756-8.909h-1.388l-1.767 4.19zM79.55 19.628c2.327 0 2.936 2.477 2.936 2.477l-4.392 1.812s.284 1.002 1.604 1.009c1.034.005 1.618-.915 1.618-.915l1.114.753s-.899 1.452-2.74 1.452c-2.263 0-3.26-1.976-3.26-3.259 0-1.236.791-3.33 3.12-3.33zm-.135 1.283c.847-.155 1.4.685 1.4.685l-2.967 1.209s-.226-1.566 1.567-1.894z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.347 16.372h1.469v9.685h-1.469z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.996 20.443v-.605l1.358.012v6.111c0 1.561-.93 3.21-3.123 3.21-2.191 0-2.899-1.94-2.899-1.94l1.247-.523s.38 1.195 1.717 1.195c1.523 0 1.7-1.383 1.7-1.857v-.663s-.526.823-1.835.823c-1.418 0-3.104-1.213-3.104-3.282s1.587-3.252 3.12-3.295c1.229-.035 1.82.814 1.82.814zm.075 2.506c0 1.117-.803 2.023-1.793 2.023-.99 0-1.793-.906-1.793-2.023 0-1.118.802-2.023 1.793-2.023.99 0 1.793.905 1.793 2.023zM66.447 22.92a3.299 3.299 0 0 1-3.305 3.294 3.299 3.299 0 0 1-3.305-3.293 3.3 3.3 0 0 1 3.305-3.293 3.3 3.3 0 0 1 3.305 3.293zm-1.469.007c0 1.106-.831 2.002-1.857 2.002s-1.858-.896-1.858-2.002c0-1.105.832-2.001 1.858-2.001 1.026 0 1.857.896 1.857 2.001zM59.297 22.92a3.299 3.299 0 0 1-3.306 3.294 3.299 3.299 0 0 1-3.305-3.293 3.3 3.3 0 0 1 3.305-3.293 3.3 3.3 0 0 1 3.306 3.293zm-1.47.007c0 1.106-.831 2.002-1.858 2.002-1.026 0-1.857-.896-1.857-2.002 0-1.105.831-2.001 1.857-2.001s1.858.896 1.858 2.001zM47.456 20.673h4.364l-.043 1.378h-4.32v-1.378z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.391 26.227c2.875.026 5.273-1.994 4.794-5.502v-.05h-1.276c.01.146.014.298.01.453.004 2.506-1.445 3.68-3.485 3.68a3.687 3.687 0 0 1-3.694-3.68 3.687 3.687 0 0 1 3.694-3.68c1.02 0 1.905.348 2.528.981l1-.996c-.85-.893-2.093-1.408-3.57-1.408-2.828 0-5.12 2.284-5.12 5.101s2.292 5.097 5.12 5.1z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.92 13.73c3.137 1.787 3.137 6.31 0 8.098l-7.588 4.322c-3.106 1.77-6.966-.474-6.966-4.05v-8.643c0-3.575 3.86-5.819 6.966-4.049l7.587 4.322z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 18,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.92 13.73c3.137 1.787 3.137 6.31 0 8.098l-7.588 4.322c-3.106 1.77-6.966-.474-6.966-4.05v-8.643c0-3.575 3.86-5.819 6.966-4.049l7.587 4.322z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.333 6.43 11.253 11.167-11.398 11.609.145-22.776z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.021 4.13 27.586 17.6l4.033-3.842L14.021 4.13z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.588 17.598 6.174 6.214-18.445 6.214 12.27-12.428z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 36.735,
    y1: 13.352,
    x2: 28.809,
    y2: 13.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.293,
    y1: 27.641,
    x2: 25.647,
    y2: 26.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.001,
    y1: 11.117,
    x2: 20.263,
    y2: 21.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 22.254,
    y1: 15.764,
    x2: 15.197,
    y2: 27.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02554"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.5ca552c0dcf017e2f806e5d9ed0aabf1.svg";
export { ForwardRef as ReactComponent };